export const DRAWER_FOOTER_AREA_DOM_ID = "drawer-footer";

// Just render a DOM element that can be used as a portal target
export const DrawerFooterArea: React.FC = () => {
  return <div id={DRAWER_FOOTER_AREA_DOM_ID} />;
};
